export const PAGE_LOAD = 'PAGE_LOAD';
export const PAGE_LOADED = 'PAGE_LOADED';
export const PAGE_UNLOADED = 'PAGE_UNLOADED';
export const PAGE_UPDATE = 'PAGE_UPDATE';
export const PAGE_CREATE = 'PAGE_CREATE';
export const PAGE_CREATE_UPDATE_SUCCESS = 'PAGE_CREATE_UPDATE_SUCCESS';
